import { MenuItemType } from '@utils/types'
import { ButtonRounded, WImage } from '@components/atoms'
import { PriceTag } from '@components/icons'
import styles from './CarouselCard.module.sass'

interface Props {
  item: MenuItemType
  className?: string
  onClick?: (e: any) => void
}

const CarouselCard = (props: Props) => {
  const { item = undefined, className = '', onClick = undefined } = props

  const classNames = `${styles.root} ${className}`
  const getContent = () => (
    <div className={`${styles.imageBox}`}>
      <WImage
        src={item.image}
        maxWidth={400}
        maxHeight={400}
        objectFit="cover"
        alt={item?.imageAlt}
        // title={item.alt}
      />
    </div>
  )

  return item ? (
    !onClick ? (
      <div className={classNames}>{getContent()}</div>
    ) : (
      <button type="button" onClick={onClick} className={classNames}>
        {getContent()}
      </button>
    )
  ) : (
    <></>
  )
}

export default CarouselCard
